"use strict";
const actionTypes = require('../actionTypes');
exports.dismissMessage = () => ({
    type: actionTypes.DISMISS_SNACKBAR_MESSAGE,
});
exports.postMessage = (message) => ({
    type: actionTypes.POST_SNACKBAR_MESSAGE,
    message,
});
exports.postAppUpdateAvailable = () => ({
    type: actionTypes.POST_SNACKBAR_APP_UPDATE_AVAILABLE,
});



/** WEBPACK FOOTER **
 ** ./src/actions/snackbar.ts
 **/